import React from 'react'
import cx from 'classnames'

import styles from './MenuItem.module.scss'

export const MenuItem = ({
  children,
  className = undefined,
  isActive = false,
}) => (
  <li
    className={cx(styles.item, {
      [styles.active]: isActive,
      [className]: Boolean(className),
    })}
  >
    {children}
  </li>
)
